import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  type IApplePayPaymentMethod,
  type IExpressPaymentMethods as IExpressPaymentMethodsServer,
  type IGooglePayPaymentMethod,
  type IPayPalPaymentMethod,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { type ExpressPaymentMethod, type ExpressPaymentMethods } from '../../../types/PaymentMethods';
import { mapApplePayPaymentMethodToCommon } from './applePay';
import { mapGooglePayPaymentMethodToCommon } from './googlePay';

export function getPaymentMethodsFromResponse(
  paymentMethodsResponse: IExpressPaymentMethodsServer,
): ExpressPaymentMethods {
  return paymentMethodsResponse.map((pm): ExpressPaymentMethod => {
    if (pm[PaymentMethod.ApplePay]) {
      return mapApplePayPaymentMethodToCommon(pm as IApplePayPaymentMethod);
    }

    if (pm[PaymentMethod.GooglePay]) {
      return mapGooglePayPaymentMethodToCommon(pm as IGooglePayPaymentMethod);
    }

    return pm as IPayPalPaymentMethod;
  });
}
